import { Component, ElementRef, Input, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import Hls from 'hls.js';
import { QuillEditorComponent } from 'ngx-quill';
import { api } from 'src/app/properties/endpoints';
import { DigitalSopService } from 'src/app/services/digital-sop.service';
import videojs from 'video.js';
import 'videojs-markers';

@Component({
  selector: 'app-digital-sop-form-preview-molecule',
  templateUrl: './digital-sop-form-preview-molecule.component.html',
  styleUrls: ['./digital-sop-form-preview-molecule.component.scss']
})
export class DigitalSopFormPreviewMoleculeComponent {
  @ViewChild('videoPlayer') videoPlayerRef!: ElementRef<HTMLVideoElement>;
  @ViewChild('target') target!: ElementRef;
  @ViewChildren('quillEditor') quillEditors!: QueryList<QuillEditorComponent>;
  @Input() formData;
  sopDetailsForm: FormGroup;
  sopStepForm: FormGroup;
  isCreatingNewSop: boolean = false;
  currentSop: any;
  // videoUrl: any;
  stream: string;
  player: any;
  markers = [];
  sopSteps: { stepName: string; startSeconds: number; endSeconds: number, instructions: string }[] = [];
  svgIcon = `<img src="data:image/svg+xml;utf8,
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512' fill='green' width='20' height='20'>
    <path d='M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v112H80c-17.7 0-32 14.3-32 32s14.3 32 
    32 32h112v112c0 17.7 14.3 32 32 32s32-14.3 
    32-32V256h112c17.7 0 32-14.3 
    32-32s-14.3-32-32-32H256V80z'/>
  </svg>" style="width: 20px; height: 20px; display: inline-block;" />`
  editorModules = {
    toolbar: {
      container: '#custom-toolbar',
    }
  };
  selectedInstructions: string = '';
  languageControl: FormControl<boolean> = new FormControl(false);

  constructor(private fb: FormBuilder, private digitalSopService: DigitalSopService,) {
  }
  ngOnInit() {
    this.initForm();
    if (this.formData != null && Object.keys(this.formData).length > 0) {
      this.isCreatingNewSop = true;
      this.fetchSop(this.formData.id);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['formData'] && changes['formData'].currentValue) {
      this.initForm();
      this.setupVideo();
      this.selectedInstructions = '';
      if (this.formData != null && Object.keys(this.formData).length > 0) {
        this.fetchSop(this.formData.id);
      }
    }
  }
  fetchSop(id) {
    this.digitalSopService.getSopById(id).subscribe((res: any) => {
      this.currentSop = res;
      this.sopSteps = [];
      if (res.steps?.length > 0) {
        this.sopSteps = res?.steps;
        this.sopSteps.forEach(step => this.addStepToForm(step));
      }
    })
  }
  private initForm() {
    this.sopDetailsForm = this.fb.group({
      name: [this.formData?.name || '', Validators.required],
      partNo: [this.formData?.partNo || '', Validators.required],
      station: [this.formData?.station || '', Validators.required]
    });
    this.sopStepForm = this.fb.group({
      steps: this.fb.array([])
    });
  }
  get steps(): FormArray {
    return this.sopStepForm.get('steps') as FormArray;
  }
  setupVideo() {
    if (this.formData?.hlsPath) {
      const video: HTMLVideoElement = this.target?.nativeElement;
      this.stream = `${api.host}${this.formData.hlsPath}`;
      if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(this.stream);  // your HLS .m3u8 stream
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play();
        });
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = this.stream;
        video.addEventListener('loadedmetadata', () => {
          video.play();
        });
      } else {
        console.error('HLS not supported in this browser.');
      }
      this.player = videojs(video);

      // this.player.markers({
      //   markers: this.markers,
      //   markerStyle: {
      //     width: '24px',
      //     height: '24px',
      //     backgroundColor: 'transparent',
      //     position: 'absolute',
      //     bottom: '0px',
      //     content: '',
      //   },
      //   markerTip: {
      //     display: false,
      //     text: (marker) => marker.text
      //   },
      //   breakOverlay:{
      //     display: false,
      //  },
      // });
      // this.player.ready(() => {
      // this.initializeMarkersFromSteps();
      // const progressControl = this.player.controlBar.progressControl.el();
      // if (progressControl) {
      //   progressControl.addEventListener('click', (event: any) => {
      //     const rect = (event.target as HTMLElement).getBoundingClientRect();
      //     const clickX = event.clientX - rect.left;
      //     const width = rect.width;
      //     const percentage = clickX / width;
      //     const duration = this.player.duration();
      //     const clickedTime = duration * percentage;
      //   });
      // }
      // });
    }
  }
  addStepToForm(step?: any) {
    const stepGroup = this.fb.group({
      startSeconds: [step?.startSeconds || 0, Validators.required],
      endSeconds: [step?.endSeconds || 0, Validators.required],
      stepName: [step?.stepName || '', Validators.required],
      instructions: [step?.instructions || '', Validators.required]
    });

    this.steps.push(stepGroup);
  }

  formatTime(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  }
  ngOnDestroy(): void {
    if (this.player) {
      this.player.dispose();
    }
  }
  ngAfterViewInit() {
    if (this.formData?.hlsPath) {
      const video: HTMLVideoElement = this.target?.nativeElement;
      this.stream = `${api.host}${this.formData.hlsPath}`;
      if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(this.stream);  // your HLS .m3u8 stream
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play();
        });
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = this.stream;
        video.addEventListener('loadedmetadata', () => {
          video.play();
        });
      } else {
        console.error('HLS not supported in this browser.');
      }
      this.player = videojs(video);

      // this.player.markers({
      //   markers: this.markers,
      //   markerStyle: {
      //     width: '24px',
      //     height: '24px',
      //     backgroundColor: 'transparent',
      //     position: 'absolute',
      //     bottom: '0px',
      //     content: '',
      //   },
      //   markerTip: {
      //     display: false,
      //     text: (marker) => marker.text
      //   },
      //   breakOverlay:{
      //     display: false,
      //  },
      // });
      // this.player.ready(() => {
      // this.initializeMarkersFromSteps();
      // const progressControl = this.player.controlBar.progressControl.el();
      // if (progressControl) {
      //   progressControl.addEventListener('click', (event: any) => {
      //     const rect = (event.target as HTMLElement).getBoundingClientRect();
      //     const clickX = event.clientX - rect.left;
      //     const width = rect.width;
      //     const percentage = clickX / width;
      //     const duration = this.player.duration();
      //     const clickedTime = duration * percentage;
      //   });
      // }
      // });
    }
  }
  initializeMarkersFromSteps() {
    if (this.sopSteps.length > 0 && this.player) {
      this.markers = [];
      // this.player?.markers?.removeAll();

      this.sopSteps.forEach((step, index) => {
        const stepIndex = index + 1;
        this.markers.push({
          time: step.endSeconds,
          text: `Step at ${this.formatTime(step.endSeconds)}`,
          class: `marker-${stepIndex}`
        });
      });
      this.player?.markers({
        markers: this.markers,
        markerStyle: {
          // width: '24px',
          height: '17px',
          backgroundColor: 'transparent',
          bottom: '0px',
          position: 'absolute',
          content: '',
        },
      });
      this.player.markers.add(this.markers)
      setTimeout(() => {
        this.markers.forEach((_, index) => {
          const stepIndex = index + 1;
          const el = document.querySelector(`.marker-1`);
          if (el) {
            el.innerHTML = '<span class="material-icons"style="font-size:16px">beenhere</span>';
          }
        });
      }, 100);
    }

  }
  playStep(step: any) {
    const instructions = step.get('instructions')?.value;
    this.selectedInstructions = instructions;
    if (this.player) {
      this.player.currentTime(step.value.startSeconds);
      this.player.play();

      const checkEndTime = () => {
        if (this.player.currentTime() >= step.value.endSeconds) {
          this.player.pause();
          this.player.off('timeupdate', checkEndTime);
        }
      };

      this.player.off('timeupdate');
      this.player.on('timeupdate', checkEndTime);
    }
  }
  insertSVG(svgContent: string, stepIndex: number) {
    const editorComponent = this.quillEditors.toArray()[stepIndex];
    const editor = editorComponent.quillEditor;

    const range = editor.getSelection(true);
    if (range) {
      editor.clipboard.dangerouslyPasteHTML(range.index, svgContent);
      const updatedHTML = editor.root.innerHTML;
      this.steps.at(stepIndex).get('instructions')?.setValue(updatedHTML);
      editor.setSelection(range.index + svgContent.length, 0);

    }
  }

}
